// extracted by mini-css-extract-plugin
module.exports = {"colorHolder":"PreviewSingleColorPopup_colorHolder__2pZen","previewContentHolder":"PreviewSingleColorPopup_previewContentHolder__2wAZo"};